export default [{
  path: 'brand-manager',
  name: 'brand-manager',
  // meta: {
  //   noLimit: true
  // },
  component: () => import('./bManager'),
  
}];



// WEBPACK FOOTER //
// ./src/views/brand/index.route.js